<script setup>
/**
 * Imports
 */
import { onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { NotificationModal } from "@/components/layout/header/components/index";
import { useNotificationStore, NOTICES_POLL_INTERVAL } from "@/modules/notifications/store";
import { useMenu } from "@/composables";
import { storeToRefs } from "pinia";
import { usePermissions } from "@/modules/auth/composables/usePermissions";

/**
 * Props, emits
 */

/**
 * Variables
 */
const router = useRouter();
const { showMenu, closeMenu, isMenuOpen } = useMenu();
const notificationStore = useNotificationStore();
const { fetchNotifications, markAsRead, markAllAsRead, startPolling, stopPolling } = notificationStore;
const { noticesCount, notifications, loading } = storeToRefs(notificationStore);
const { hasAccess } = usePermissions();

/**
 * Computed
 */

/**
 * Methods
 */
// Открытие шторки: подгружаем свежий список (20 последних)
const open = () => {
  showMenu();
  fetchNotifications({ per_page: 20 });
};

const handleRead = (notification) => {
  if (!hasAccess("notice:read")) return;
  markAsRead(notification.id).catch(() => {});
};

const handleReadAll = () => {
  if (!hasAccess("notice:read")) return;
  markAllAsRead().catch(() => {});
};

// Клик по уведомлению: помечаем прочитанным и ведём на заявку либо на страницу возвратов
const handleOpen = async (notification) => {
  handleRead(notification);
  closeMenu();

  const applicationId = notification?.payload?.application_id;
  const type = String(notification?.type || "");

  if (applicationId && hasAccess("application:show")) {
    await router.push({ name: "request-open", params: { id: applicationId } });
  } else if (type.includes("return") && hasAccess("application:return_index")) {
    await router.push({ name: "returns" });
  }
};

/**
 * Hooks, watchers and calls
 */
onMounted(() => {
  // Polling счётчика непрочитанных каждые 60 с (websocket в проекте нет)
  startPolling(NOTICES_POLL_INTERVAL);
});

onUnmounted(() => {
  stopPolling();
});
</script>

<template>
  <button class="header__notification btn btn--md btn--gray-light" @click="open">
    <IconComponent name="bell" />
    <span v-if="noticesCount" class="header__notification-tag">
      {{ noticesCount > 99 ? "99+" : noticesCount }}
    </span>
  </button>
  <NotificationModal
    :show="isMenuOpen"
    :notifications="notifications"
    :loading="loading"
    :count="noticesCount || 0"
    @close="closeMenu"
    @read="handleRead"
    @read-all="handleReadAll"
    @open="handleOpen"
  />
</template>

<style lang="stylus">
.header__notification {
  cursor: pointer;
  position relative

  .icon {
    width: 24px;
    height: 24px;
  }

  &-tag {
    position absolute
    top 0
    right 0
    border-radius: 4px;
    background: var(--red, #E31E24);
    min-width 15px
    height 15px
    padding: 2px
    color: var(--white, #FFF);
    text-align: center;
    font-size: 0.625rem
    font-weight: 500;
    line-height: normal;
    display flex
    align-items center
    justify-content center
  }
}
</style>
